import { all } from 'redux-saga/effects';

import { saga as brandingSaga } from 'modules/branding';
import { saga as hellosignSaga } from 'modules/hellosign';

/**
 * Define the root saga
 *
 * @method rootSaga
 */
function* rootSaga() {
    yield all([brandingSaga(), hellosignSaga()]);
}

export default rootSaga;
